import React from 'react';
import classNames from 'classnames';
import './SVGIcon.scss';
import { ReactComponent as InProgress } from '../../../Assets/icons/in-progress.svg';
import { ReactComponent as InProgressLight } from '../../../Assets/icons/in-progress-light.svg';
import { ReactComponent as Open } from '../../../Assets/icons/open.svg';
import { ReactComponent as OpenLight } from '../../../Assets/icons/open-light.svg';
import { ReactComponent as Checkmark } from '../../../Assets/icons/checkmark.svg';
import { ReactComponent as CheckmarkLight } from '../../../Assets/icons/checkmark-light.svg';
import { ReactComponent as Enterprise } from '../../../Assets/icons/enterprise.svg';
import { ReactComponent as Escalated } from '../../../Assets/icons/escalated.svg';
import { ReactComponent as TableView} from '../../../Assets/icons/tableView.svg';
import { ReactComponent as GridView } from '../../../Assets/icons/gridView.svg';

export const iconMapping = {
  'inProgress': <InProgress />,
  'inProgressLight': <InProgressLight />,
  'open': <Open />,
  'openLight': <OpenLight />,
  'checkmark': <Checkmark/>,
  'checkmarkLight': <CheckmarkLight/>,
  'enterprise':<Enterprise/>,
  'escalated':<Escalated/>,
  'tableView':<TableView/>,
  'gridView':<GridView/>
};

export default function SVGIcon({ icon, className, ...props }) {
  return (
    <div className={classNames('icon', 'icon-' + icon, className,)} {...props} >
      {iconMapping[icon] ? iconMapping[icon] : ''}
    </div>
  );
}
